import React, {useState, useEffect, useContext} from 'react'
import Link from 'next/link'

import {
  getGlobalLeaderboard,
  fetchRank,
  getGlobalStats,
  getFriendsGlobalLeaderboard,
} from 'src/util/db'

import {UserContext} from 'src/contexts'

import {useLocalStorage} from 'src/hooks/useLocalStorage.js'

import {AsideLeaderBoard} from '@components/AsideLeaderboard'

const GlobalLeaderBoard = ({numOfPlayersToShow = 10}) => {
  const user = useContext(UserContext)

  const [leaderboard, setLeaderboard] = useState([])
  const [rankData, setRankData] = useState({})
  const [isFetchingLeaderboard, setIsFetchingLeaderboard] = useState()
  const [isFriendsMode, setIsFriendsMode] = useLocalStorage(
    'showFriendsLeaderboard',
    !!user
  )
  const [globalStats, setGlobalStats] = useState({playerCount: 0})
  useEffect(() => {
    getGlobalStats().then(setGlobalStats)
  }, [])

  useEffect(() => {
    setIsFetchingLeaderboard(true)
    ;(isFriendsMode && user
      ? getFriendsGlobalLeaderboard({userId: user.uid})
      : getGlobalLeaderboard(numOfPlayersToShow)
    ).then((leaderboard) => {
      // Get top 10 players
      setLeaderboard(leaderboard)
      setIsFetchingLeaderboard(false)

      if (!leaderboard.length) {
        setRankData({})
      }

      // We got a logged in user
      if (user && leaderboard.length) {
        // Is the player already in top 10? If yes, find rank from fetched leaderboard
        if (leaderboard.find((player) => player.id === user.uid)) {
          const player = leaderboard.find((player) => player.id === user.uid)
          setRankData({
            rank: leaderboard.findIndex((player) => player.id === user.uid) + 1,
            score: player.score,
            totalPlayers: 0,
          })
        } else {
          // Else, find his rank again from backend

          fetchRank({userId: user.uid})
            .then((result) => {
              setRankData(result)

              // Insert the current player to end of the leaderboard
              // setLeaderboard([
              //   ...leaderboard,
              //   {
              //     score: result.score,
              //     playerProfile: {...user, avatar: user.photoURL},
              //     id: user.uid,
              //     rank: result.rank,
              //     playedCount: result.playedCount,
              //   },
              // ])
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
    })
  }, [user ? user.uid : '', isFriendsMode])

  function leaderboardTypeChangeHandler(e) {
    setIsFriendsMode(e.target.value === 'friends')
  }

  return (
    <AsideLeaderBoard
      type="global"
      title="All-time leaders"
      leaderboard={leaderboard}
      rankData={rankData}
      isFetchingLeaderboard={isFetchingLeaderboard}
      isFriendsMode={isFriendsMode}
      onLeaderboardFriendTypeChange={leaderboardTypeChangeHandler}
      noRankMessage="You need at least a score of 10000 to see your rank."
      footer={
        <Link href="/leaderboard">
          <a className="button  button--full-width">See top 100</a>
        </Link>
      }
    />
  )
}

export {GlobalLeaderBoard}
